module.exports = __webpack_public_path__ + "img/accessory_hat_12.35d1fdf7.svg";